{
  "name": "pacote",
  "version": "15.0.8",
  "description": "JavaScript package downloader",
  "author": "GitHub Inc.",
  "bin": {
    "pacote": "lib/bin.js"
  },
  "license": "ISC",
  "main": "lib/index.js",
  "scripts": {
    "test": "tap",
    "snap": "tap",
    "lint": "eslint \"**/*.js\"",
    "postlint": "template-oss-check",
    "lintfix": "npm run lint -- --fix",
    "posttest": "npm run lint",
    "template-oss-apply": "template-oss-apply --force"
  },
  "tap": {
    "timeout": 300,
    "nyc-arg": [
      "--exclude",
      "tap-snapshots/**"
    ]
  },
  "devDependencies": {
    "@npmcli/arborist": "^6.0.0 || ^6.0.0-pre.0",
    "@npmcli/eslint-config": "^4.0.0",
    "@npmcli/template-oss": "4.11.0",
    "hosted-git-info": "^6.0.0",
    "mutate-fs": "^2.1.1",
    "nock": "^13.2.4",
    "npm-registry-mock": "^1.3.2",
    "tap": "^16.0.1"
  },
  "files": [
    "bin/",
    "lib/"
  ],
  "keywords": [
    "packages",
    "npm",
    "git"
  ],
  "dependencies": {
    "@npmcli/git": "^4.0.0",
    "@npmcli/installed-package-contents": "^2.0.1",
    "@npmcli/promise-spawn": "^6.0.1",
    "@npmcli/run-script": "^6.0.0",
    "cacache": "^17.0.0",
    "fs-minipass": "^3.0.0",
    "minipass": "^4.0.0",
    "npm-package-arg": "^10.0.0",
    "npm-packlist": "^7.0.0",
    "npm-pick-manifest": "^8.0.0",
    "npm-registry-fetch": "^14.0.0",
    "proc-log": "^3.0.0",
    "promise-retry": "^2.0.1",
    "read-package-json": "^6.0.0",
    "read-package-json-fast": "^3.0.0",
    "ssri": "^10.0.0",
    "tar": "^6.1.11"
  },
  "engines": {
    "node": "^14.17.0 || ^16.13.0 || >=18.0.0"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/npm/pacote.git"
  },
  "templateOSS": {
    "//@npmcli/template-oss": "This file is partially managed by @npmcli/template-oss. Edits may be overwritten.",
    "version": "4.11.0",
    "windowsCI": false
  }
}
